// Modules
import axios from 'axios';
import moment from 'moment';
import { useCallback, useEffect, useState } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import DOMPurify from 'dompurify';
import { useSelector } from 'react-redux';

// CSS
import '_Asset/css/Admin/Page/admin.css'

// Component
import { Pagination } from 'User/Component';
import {
  Paging, // Paging
  CurPageList, // 전체 리스트 정렬 및 현재 페이지 리스트 출력
  SetSortIco, // 정렬 아이콘 변경
  HandleSingleCheck, HandleAllCheck, // 체크박스 단일, 전체 선택
  HighlightedText, // 검색어 하이라이팅
  fileDownload
} from 'Admin/Component/AdFunc';

// API
import { AdJoinApi, apiHost } from '_Route/Api';
import Loading from 'Admin/Component/Loading';


const AdJoin = () => {

  // Using Hooks
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const sanitizer = DOMPurify.sanitize;

  const [loading, setLoading] = useState(false);
  const [guideStatus, setGuideStatus] = useState(true);
  const [joinData, setJoinData] = useState({
    pageList: [], // Join Page List
    resList: [], // Join Result List
  })
  const { pageList, resList } = joinData

  const sessionID = localStorage.getItem('memSessionID')
  // const imgHost = process.env.REACT_APP_IMG_HOST;
  const userScore = useSelector(state => state.authorityAcc.access_score);
  const master = useSelector(state => state.authorityAcc.master);
  
  // 필터 옵션
  const [filterOpt, setFilterOpt] = useState({
    search_key: '',
    search_val: params.key || '',
    join_foreigner: '',
    join_gender: '',
    join_date: '',
    join_status: '',
  })
  const { search_key, search_val, join_foreigner, join_gender, join_date, join_status } = filterOpt;

  // Paging var
  const [curPage, setCurPage] = useState(1) // 현제 페이지
  const blockSize = 10 // Pagination 블럭 갯수
  const [pageSize, setPageSize] = useState(10) // 한 페이지에 노출할 게시물 갯수
  const [count, setCount] = useState('');

  // Column name / Sort var
  const columnList = [
    {name: 'No', key: 'join_no'},
    {name: '채용 글 제목', key: 'incruit_title'},
    {name: '내/외국인 구분', key: 'join_foreigner'},
    {name: '이름', key: 'join_name'},
    {name: '이메일', key: 'join_email'},
    {name: '생일', key: 'join_birth'},
    {name: '성별', key: 'join_gender'},
    {name: '지원 글 제목', key: 'join_title'},
    {name: '지원 글 내용', key: 'join_content'},
    {name: '이력서', key: 'join_file'},
    {name: '지원 일시', key: 'join_date'},
    {name: '지원 상태', key: 'join_status'},
    {name: '수정', key: 'join_use', access_score: 300},
  ]; 
  const [sortIdx, setSortIdx] = useState(0);
  const [sortType, setSortType] = useState('');
  const [sortState, setSortState] = useState('expand'); // expand, up(DECS), down(ASC);

  // CheckBox var
  const [checkItems, setCheckItems] = useState([]);


  /*========================================================================
  * onHandler Func
  ========================================================================*/
  const onFilter = (e) => {
    const { name, value } = e.target;
    setFilterOpt({...filterOpt, [name]: value});
  }
  
  const onKeyPress = (e) => { if(e.key == 'Enter') onSearch(); }
  const onSearch = () => {
    navigate(`/admin/dev-employ/join/list${search_val === '' ? '' : '/' + encodeURIComponent(search_val)}`);
  }


  /* ========================================================================
  * Axios Join
  ========================================================================*/
  const [update, setUpdate] = useState(false); // 리스트 상태 업데이트 변수 

  // GET Join List
  useEffect(() => {
    setLoading(false)
    axios.get(AdJoinApi, {
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      params: filterOpt
    })
    .then(res => {
      // console.log(res, 'GET Join List Success!')
      const sortData = res.data.result;
      
      joinData.pageList = res.data.pageInfo
      joinData.resList = CurPageList(sortData, sortType, sortState, curPage, pageSize)
      setJoinData({...joinData})
      setCount(res.data.result.length);
    })
    .catch(err => {
      console.error("GET Join List ERROR...", err);
    })
    .finally(() => {
      setLoading(true)
    })
  }, [location, pageSize, curPage, sortState, sortIdx, update, search_key, join_foreigner, join_gender, join_date, join_status])
  
  // DELETE Join
  const DeleteJoin = (joinUuid, index) => {
    axios({
      url: AdJoinApi,
      method: 'DELETE',
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      data: {
        join_uuid: joinUuid,
        approve_spec_status: 0,
        approve_ap_status: 0,
      }
    })
    .then(res => {
      // console.log("DELETE Join List Success!", res);
      if(index === checkItems.length - 1) {
        alert(`${checkItems.length}명의 지원자 삭제${master === 1 ? '를' : ' 요청을'} 완료하였습니다.`)
      }
      setUpdate(!update)
    })
    .catch(err => {
      console.error("DELETE Join List ERROR...", err);
      const errMsg = err.response.data.message
      if (errMsg && index === 0) { alert(errMsg); }
    })
  }
  
  // 일괄 삭제 함수
  const deleteFunc = () => {
    if(checkItems.length === 0) {
      alert('삭제할 지원자를 선택해주세요.')
    } else {
      if(window.confirm(`${checkItems.length}명의 지원자를 선택하셨습니다. \n정말 삭제${master === 1 ? '' : '를 요청'}하시겠습니까?`)) {
        checkItems.map((id, i) => { DeleteJoin(id, i) })
        setCheckItems([])
      }
    }
  }


  return (
    <>
      <div className="adContTitGroup">
        <h2>지원자 관리</h2>
        <p>Home / 개발자 채용 / 지원자 관리 <button type="button" onClick={() => setGuideStatus(!guideStatus)}><i className="icofont-info-circle" /> 가이드 {guideStatus ? '접기' : '보기'} <i className={`icofont-rounded-${guideStatus ? 'up' : 'down'}`} /></button></p>

        <ul className={`subMsg ${guideStatus ? '' : 'off'}`}>
          <li>* 개발자 채용 지원자 정보를 <span className="blueTxt">조회/관리</span>할 수 있습니다.</li>
        </ul>
      </div>

      <div className="adContArea list">

        <div className="flexBox between">
          <div className="adListBox">
            {
              userScore >= 300 &&
              <button type="button" className="btn xs red round_10" onClick={deleteFunc}>선택 삭제</button>
            }
            
            <div className="fieldGroup">
              <label>노출 게시물 수</label>

              <div className="field">
                <select className="select sm type_1 round_10" onChange={(e) => setPageSize(e.target.value)} defaultValue="10">
                  <option value="10">10개 씩</option>
                  <option value="30">30개 씩</option>
                  <option value="50">50개 씩</option>
                  <option value="100">100개 씩</option>
                </select>
              </div>
            </div>

            <div className="fieldGroup">
              <label>내/외국인 구분</label>

              <div className="field full">
                <select name="join_foreigner" className="select sm type_1 round_10" onChange={(e) => onFilter(e)}>
                  <option value="">전체</option>
                  <option value="내국인">내국인</option>
                  <option value="외국인">외국인</option>
                </select>
              </div>
            </div>

            <div className="fieldGroup">
              <label>성별</label>

              <div className="field">
                <select name="join_gender" className="select sm type_1 round_10" onChange={(e) => onFilter(e)}>
                  <option value="">전체</option>
                  <option value="남자">남자</option>
                  <option value="여자">여자</option>
                </select>
              </div>
            </div>

            <div className="fieldGroup">
              <label>지원 일시</label>

              <div className="field">
                <select name="join_date" className="select sm type_1 round_10" onChange={(e) => onFilter(e)}>
                  <option value="">전체</option>
                  <option value="to">오늘</option>
                  <option value="day">어제</option>
                  <option value="week">최근 1주일</option>
                  <option value="month">최근 1개월</option>
                  <option value="year">최근 1년</option>
                </select>
              </div>
            </div>

            <div className="fieldGroup">
              <label>지원 상태</label>

              <div className="field">
                <select name="join_status" className="select sm type_1 round_10" onChange={(e) => onFilter(e)}>
                  <option value="">전체</option>
                  <option value="진행중">진행중</option>
                  <option value="모집종료">모집 종료</option>
                  <option value="합격">합격</option>
                  <option value="불합격">불합격</option>
                </select>
              </div>
            </div>
          </div>

          <div className="adListBox">
            <div className="fieldGroup row gap">
              <label>콘텐츠 검색</label>

              <div className="field gap">
                <select className="select sm type_1 round_10" name="search_key" onChange={(e) => onFilter(e)}>
                  <option value="">통합검색</option>
                  <option value="incruit_title">채용 글 제목</option>
                  <option value="join_name">이름</option>
                  <option value="join_email">이메일</option>
                  <option value="join_birth">생일</option>
                  <option value="join_title">지원 글 제목</option>
                  <option value="join_content">지원 글 내용</option>
                </select>
                <div className="inputIco">
                  <input type="text" className="input sm type_1 i_rt round_10" name="search_val" value={search_val} onChange={(e) => onFilter(e)} onKeyPress={onKeyPress} placeholder="검색어를 입력해주세요." />
                  <button type="button" className="icofont-search" onClick={onSearch}></button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="table list_2">
          <table>
            <thead>
              <tr>
                <th className="check">
                  <div className="checkGroup">
                    <input type="checkbox" className='check sm blue' id="allCheck" onChange={(e) => setCheckItems(HandleAllCheck(e.target.checked, resList, 'join_uuid'))} checked={checkItems.length === resList.length ? true : false}/>
                    <label htmlFor="allCheck"></label>
                  </div>
                </th>
                {columnList.map((list, i) =>
                  (userScore >= list?.access_score || list.access_score === undefined) && 
                  <th key={i} onClick={() => {setSortState(SetSortIco(i, sortIdx, sortState)); setSortIdx(i); setSortType(list.key)}}>{list.name}<i className={`icofont-rounded-${i === sortIdx ? sortState : 'expand'}`}></i></th>
                )}
              </tr>
            </thead>
            <tbody>
              {loading ?
                resList.length !== 0 ?
                  resList.map((data, i) => 
                    <tr key={i}>
                      <td>
                        <div className="checkGroup">
                          <input type="checkbox" className='check sm blue' id={`check_${i}`} onChange={(e) => setCheckItems(HandleSingleCheck(e.target.checked, data.join_uuid, checkItems))} checked={checkItems.includes(data.join_uuid) ? true : false}/>
                          <label htmlFor={`check_${i}`}></label>
                        </div>
                      </td>
                      <td>{data.join_no}</td>
                      <td>{data.incruit_title}</td>
                      <td>{data.join_foreigner}</td>
                      <td>{data.join_name}</td>
                      <td>{data.join_email}</td>
                      <td>{data.join_birth}</td>
                      <td>{data.join_gender}</td>
                      <td style={{minWidth: '150px', maxWidth: '300px'}} dangerouslySetInnerHTML={{ __html: sanitizer(data.join_title)}}></td>
                      <td style={{minWidth: '250px', maxWidth: '400px'}} dangerouslySetInnerHTML={{ __html: sanitizer(data.join_content)}}></td>
                      <td><button type="button" className="fileLink" title="파일 다운로드" onClick={() => fileDownload('join', data.join_file)}>{data.join_file}</button></td>
                      <td>{moment(data.join_date).format('YYYY-MM-DD HH:mm')}</td>
                      <td>{data.join_status}</td>
                      {
                        userScore >= 300 &&
                        <td style={{width: '125px'}}>
                          <div className="btnArea col full">
                            <button type="button" className="btn xxs green round_10" onClick={() => navigate(`/admin/dev-employ/join/view/${data.join_uuid}`)}>지원 상태 수정</button>
                          </div>
                        </td>
                      }
                    </tr>
                  )
                  :
                  <tr>
                    <td colSpan={columnList.length + 1}>
                      <div className="noData">
                        <i className="icofont-warning-alt"></i>
                        <p>데이터가 존재하지 않습니다.</p>
                      </div>
                    </td>
                  </tr>
                :
                <tr><td colSpan={columnList.length + 1}><Loading type="tbLoad" /></td></tr>
              }
            </tbody>
          </table>
        </div>

        <div className="flexBox between paginationBox">
          <p>Showing {curPage} to {pageSize} of {pageList?.count} entries</p>

          <Pagination
            type="type_1"
            size="sm"
            curPage={curPage}
            setCurPage={setCurPage}
            pageSize={pageSize}
            blockSize={blockSize}
            startBlock={Paging(curPage, blockSize, pageSize, count).startBlock}
            endBlock={Paging(curPage, blockSize, pageSize, count).endBlock}
            pageCount={Paging(curPage, blockSize, pageSize, count).pageCount}
          />
        </div>
      </div>
    </>
  )
}

export default AdJoin;